import clsx from 'clsx';
import styles from './Disclaimer.module.scss';

interface DisclaimerProps extends React.HTMLAttributes<HTMLParagraphElement> {
  id?: string;
  children: React.ReactNode;
  className?: string;
  tone?: 'default' | 'text';
}

export const Disclaimer = ({
  id,
  children,
  className,
  tone = 'default',
  ...props
}: DisclaimerProps) => (
  <p
    className={clsx(styles.disclaimer, className, {
      [styles.toneText]: tone === 'text',
    })}
    id={id}
    {...props}
  >
    {children}
  </p>
);
